/* 布局 */
//前台
import Layout from "@views/layout";

const goodsmanagepriceRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
        path: "goodsmanageprice/list",
        name: "GOODSMANAGEPRICE",
        meta: {
            title: "墓穴续费套餐",
            keepAlive:true
        },
        component: () => import("@views/business/goodsmanageprice/index.vue"),
    },
        ],
};

export default goodsmanagepriceRouter;
